import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Bell, MessageSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NotificationsBell() {
  const [count, setCount] = useState(0);
  const [recent, setRecent] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const refresh = async () => {
    try {
      const c = await api.get("/notifications/unread-count");
      setCount(c.data.count || 0);
    } catch {}
  };
  const loadRecent = async () => {
    try {
      const { data } = await api.get("/notifications", { params: { limit: 8 } });
      setRecent(data);
    } catch {}
  };

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/mark-all-read");
    refresh(); loadRecent();
  };

  return (
    <DropdownMenu open={open} onOpenChange={(o) => { setOpen(o); if (o) loadRecent(); }}>
      <DropdownMenuTrigger asChild>
        <button
          className="relative w-8 h-8 rounded-md border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center"
          data-testid="notifications-bell"
        >
          <Bell size={15} className="text-slate-700" />
          {count > 0 && (
            <span className="absolute -top-1 -right-1 bg-rose-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center" data-testid="bell-count">
              {count > 9 ? "9+" : count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-96" data-testid="notifications-dropdown">
        <DropdownMenuLabel className="flex items-center justify-between">
          <span>Notifications (MOCKED)</span>
          <button onClick={markAll} className="text-xs text-blue-600 font-medium hover:underline" data-testid="mark-all-read">
            Mark all read
          </button>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {recent.length === 0 && (
          <div className="px-4 py-6 text-sm text-slate-400 text-center">No notifications yet.</div>
        )}
        {recent.map((n) => (
          <DropdownMenuItem
            key={n.id}
            onClick={() => navigate(`/notifications`)}
            className="flex flex-col items-start gap-1 cursor-pointer"
            data-testid={`notification-${n.id}`}
          >
            <div className="flex items-center gap-2 w-full">
              <MessageSquare size={12} className="text-slate-500" />
              <span className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                {n.channel} → {n.recipient_role}
              </span>
              {!n.is_read && <span className="ml-auto bg-rose-500 w-1.5 h-1.5 rounded-full"></span>}
            </div>
            <div className="text-xs text-slate-700 truncate w-full">{n.message}</div>
            <div className="text-[10px] text-slate-400 font-mono">{n.complaint_number} · to {n.to}</div>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/notifications")} className="text-blue-600 font-medium justify-center" data-testid="view-all-notifications">
          View all
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
